
<div class="modal-container">
  <div class="modal-header">
    <h3 class="modal-title-text"><i class="fa fa-sync"></i> Actualizar Saldos de Categoría</h3>
  </div>
  <div class="modal-body">
    <div class="alert alert-info custom-alert-info">
      Este proceso actualizará todos los saldos de los alumnos que no estén pagados completamente, desde el mes y año elegido para la categoría: <strong>{{ categoriaNombre }}</strong>. Puede aplicar solo al mes y año seleccionado y también a un grado específico.
    </div>

    <div class="row">
      <div class="form-group col-sm-6 col-md-3">
        <label for="mes" class="form-label">Mes</label>
        <select name="mes" id="mes" class="form-control custom-select" required [(ngModel)]="mes">
          <option *ngFor="let c of meses.list" [value]="c.id">
            {{ c.descripcion }}
          </option>
        </select>
      </div>
      <div class="form-group col-sm-6 col-md-3">
        <label for="anio" class="form-label">Año</label>
        <select name="anio" id="anio" class="form-control custom-select" required [(ngModel)]="anio">
          <option *ngFor="let c of anios.list" [value]="c.id">
            {{ c.descripcion }}
          </option>
        </select>
      </div>
      <div class="form-group col-md-3 checkbox-container">
        <div class="custom-checkbox">
          <input
            id="soloEsteFecha"
            type="checkbox"
            class="filled-in chk-col-light-blue"
            [(ngModel)]="soloEsteFecha"
          />
          <label for="soloEsteFecha">Solo esta fecha</label>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="form-group col-md-6">
        <label for="gradoId" class="form-label">Grado</label>
        <select
          id="gradoId"
          [(ngModel)]="gradoId"
          name="gradoId"
          class="form-control custom-select"
          required
        >
          <option *ngFor="let c of grados" [value]="c.id">
            {{ c.nombre }}
          </option>
        </select>
      </div>
      <div class="form-group col-md-6 checkbox-container">
        <div class="custom-checkbox">
          <input
            id="soloEsteGrado"
            type="checkbox"
            class="filled-in chk-col-light-blue"
            [(ngModel)]="soloEsteGrado"
          />
          <label for="soloEsteGrado">Solo este Grado</label>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="text-center w-100" *ngIf="loading">
      <span class="badge badge-danger p-2"><i class="fa fa-spinner fa-spin"></i> Procesando, espere un momento...</span>
    </div>
    <div class="action-buttons-container" *ngIf="!loading">
      <button type="button" class="btn btn-danger custom-btn-danger" (click)="actualizar()">
        <i class="fa fa-check"></i> Actualizar Saldos
      </button>
      <button type="button" class="btn btn-secondary custom-btn-secondary" (click)="cancelar()">
        Cancelar
      </button>
    </div>
  </div>
</div>
